import api from './index';

interface GetAvailabilityProps {
  dateFrom: string;
  dateTo: string;
}
const getAvailability = (props: GetAvailabilityProps) => {
  return api.get(`/v4/liveclass/availability?date_from=${props.dateFrom}&date_to=${props.dateTo}`);
};

interface PostReserveProps {
  datetime: string;
  topic_id: number;
  type_id: string;
}
const postReserve = (props: PostReserveProps) => {
  return api.post(`/v4/liveclass/reserve`, props);
};

interface CancelLiveClassProps {
  liveclass_id: number;
}
const cancelLiveClass = (props: CancelLiveClassProps) => {
  return api.delete(`/v4/liveclass/${props.liveclass_id}`);
};

interface PostConfirmPresenceProps {
  liveclass_id: number;
}
const postConfirmPresence = (props: PostConfirmPresenceProps) => {
  return api.put(`/v4/liveclass/${props.liveclass_id}/confirm`);
};

interface PostCancelPresenceProps {
  liveclass_id: number;
}
const postCancel = (props: PostCancelPresenceProps) => {
  return api.delete(`/v4/liveclass/${props.liveclass_id}`);
};

const getCheckJoin = () => {
  return api.get(`/v4/liveclass/check`);
};

const getJoinLink = () => {
  return api.get(`/v4/liveclass/join`);
};

interface Play2LearnZoomPageProps {
  meetingNumber: string;
  userName: string;
  sdkKey: string;
  signature: string;
  meetingLink: string;
  serviceTeamUrl: string;
  helpCenterUrl: string;
  mobileEnabled: boolean;
}
const getPlay2LearnMeeting = async () => {
  const { data } = await api.get<Play2LearnZoomPageProps>(`/v4/api/liveclass/p2l/player`);
  return data;
};

export const LiveClassBookingService = {
  getAvailability,
  postReserve,
  cancelLiveClass,
  postConfirmPresence,
  postCancel,
  getCheckJoin,
  getJoinLink,
  getPlay2LearnMeeting,
};
